import { defineAsyncComponent } from 'vue';

export default {
  'form-step-1': defineAsyncComponent(() => import(/* webpackChunkName: "forms" */ './FormStep1.vue')),
  'form-step-2': defineAsyncComponent(() => import(/* webpackChunkName: "forms" */ './FormStep2.vue')),
  'form-step-3': defineAsyncComponent(() => import(/* webpackChunkName: "forms" */ './FormStep3.vue')),
  'form-step-4': defineAsyncComponent(() => import(/* webpackChunkName: "forms" */ './FormStep4.vue'))
}
